import { createAction, props } from '@ngrx/store';
import { ErrorInterface } from '../../interfaces/general.interface';
import { ChangePasswordInterface } from '../../interfaces/auth.interface';

enum ChangePasswordActionType {
  changePassword = '[change password] change Password',
  requestSuccess = '[change password] success change Password',
  requestError = '[change password] error change Password',
  clearPassword = '[change password] clear change Password',
}

export const changePassword = createAction(
  ChangePasswordActionType.changePassword,
  props<{ params: ChangePasswordInterface }>()
);

export const requestSuccess = createAction(
  ChangePasswordActionType.requestSuccess,
  props<{ response: any }>()
);

export const requestError = createAction(
  ChangePasswordActionType.requestError,
  props<{ error: ErrorInterface }>()
);

export const clearPassword = createAction(
  ChangePasswordActionType.clearPassword
);
